import React, { Component } from "react";

export default class CheckBox extends Component {
  render() {
    return (
      <div className="flex checkbox_group">
        <label>
          <span className="check-box">
            <input type="checkbox" {...this.props} className="check" />
            <span className="tick"></span>
          </span>
          <span style={{ marginLeft: "10px", display: 'flex', alignItems: 'center' }}> {this.props.label}</span>
        </label>
      </div>

    );
  }
}
